import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {Headers, Http, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {Construct} from 'classes/construct';
import {ContentUsage, Dialog} from 'classes/dialog';
import {Question} from 'classes/question';
import {TargetGroup} from 'shared/models/target-groups/target-group';

import {environment} from 'environment';

@Injectable()
export class DialogsDetailsRepository {

  constructor(private http: Http) { }

  public getDialogById(id: number): Observable<Dialog> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.dialogs}/${id}`, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawDialog: Dialog) => {
        return Dialog.create(rawDialog);
      });
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public saveDialog(dialog: Dialog): Observable<Dialog> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify(this.prepareDialogForBackend(dialog));

    return this.http.post(environment.dialogs, body, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawDialog: Dialog) => {
        return Dialog.create(rawDialog);
      });
  }

  public updateDialog(dialog: Dialog): Observable<Dialog> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: string = JSON.stringify(this.prepareDialogForBackend(dialog));

    return this.http.put(`${environment.dialogs}/${dialog._id}`, body, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawDialog: Dialog) => {
        return Dialog.create(rawDialog);
      });
  }

  private prepareDialogForBackend(dialog: Dialog): any { // tslint:disable-line:no-any
    const newDialog: any = { // tslint:disable-line:no-any
      id: dialog._id,
      title: dialog.title,
      description: dialog.description,
      active: dialog.active,
      urgent: dialog.urgent,
      startDate: dialog.startDate,
      endDate: dialog.endDate,
      intervalUnit: dialog.intervalUnit,
      intervalValue: dialog.intervalValue,
      activeDuration: dialog.activeDuration,
      isDistributed: dialog.isDistributed,
      targetGroup: dialog.targetGroup._id,
      questions: this.getQuestionIds(dialog.questions),
    };

    if (dialog.goal) {
      newDialog.goal = dialog.goal;
    }

    if (dialog.contSuggest) {
      newDialog.contSuggest = dialog.contSuggest;
    }

    return newDialog;
  }

  private getQuestionIds(questions: Array<Question>): Array<number> {
    return questions.map((question) => {
      return question._id;
    });
  }

  public getContentUsages(id: number): Observable<Array<ContentUsage>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.contents}/usageDialog/${id}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-details/repositories/dialogs-details.repository.ts